// 发布项目模块
export default {
    PublishProject: {
        StartPublishing: '開始發布',
        ShareableQuestionnaire: '開啟發布後，即可分享問卷',
        ProjectSharing: '項目分享',
        LinkRemainsUnchanged: '項目發布後，鏈接與二維碼始終不變',
        ShareLink: '分享鏈接',
        Copy: '復制',
        Open: '打開',
        QRCode: '二維碼',
        DownloadQRCode: '下載二維碼',
        WeChatSharing: '微信分享',
        UploadLogo: '上傳Logo',
        ShareLogo: '分享logo',
        ClickToUpload: '點擊上傳',
        ClickToDelete: '點擊刪除',
        ImageSupport: '圖片支持png、jpg格式,建議尺寸100*100',
        InputContent: '請輸入連絡人姓名',
        ShareTitle: '分享標題',
        ShareDescriptionDescription: '分享描述說明',
        FriendSharingPreview: '好友分享預覽',
        ShareMomentPreview: '分享朋友圈預覽',
        WeChatAvatar: '微信頭像',
        WeChatNickname: '微信昵稱',
        SMSSharing: '短信分享',
        ViewSentTextMessages: '查看已發送短信',
        AddRecipient: '添加收件人',
        EditContent: '編輯內容',
        Sent: '已經發送',
        BriefIntroduction: '您可以從左側聯系人列表中添加，或手動輸入“手機號,姓名”，每行代表一個聯系人，姓名可以出現在短信正文中。例如：136xxxxxxxx,宋先生',
        ContactList: '聯系人列表',
        Add: '添加',
        ManuallyEnteringContacts: '手動輸入聯系人',
        NumberOfRecipients: '收件人數',
        NextStep: '下一步',
        InstructionsForUse: '使用須知：',
        InstructionsForUse1: '1.您發送的短信需要經過內容審核',
        InstructionsForUse2: '2.短信擡頭將顯示為【東方艾學代發】',
        InstructionsForUse3: '3.發送成功後，可以查看已發短信的進度',
        InstructionsForUse4: '4.$[name]表示聯系人姓名 $[surveylink]表示問卷地址',
        InstructionsForUse5: '5.給異常的手機號（包括停機，空號等）發送短信，也會扣除短信余額或賬戶余額',
        Back: '上一步',
        Sending: '發送',
        SubmittedForSending: '已經提交發送。',
        SMSSent: '已發送短信',
        SMSContent: '短信內容',
        NumberOfSenders: '發送人數',
        SendingTime: '發送時間',
        State: '狀態',
        SMSDelivered: '短信已投遞',
        SMSNotDelivered: '短信未投遞',
        SMSDeliveryFailed: '短信投遞失敗',
        Reason: '原因',
        Operate: '操作',
        ViewDetails: '查看詳情',
        BackSentSMSList: '返回已發送短信列表',
        PhoneNumber: '手機號碼',
        Name: '姓名',
        Success: '成功',
        Fail: '失敗',
        EmailSharing: '郵件分享',
        ViewSharedEmails: '查看已分享郵件',
        SelectSendingMethod: '選擇發送方式',
        EmailContactDescription: '您可以從左側“通訊錄”中批量添加，或在右側手動輸入收件人郵箱（或“郵箱,姓名”）。每次最多添加500個。',
        InstructionsForUse: '使用說明：“$[name]”表示收件人姓名，“$[surveylink]”表示測評地址',
        Addresser: '發件人',
        SenderEmail: '發件人郵箱',
        Theme: '主題',
        SendViaEmail: '使用神采問卷郵箱發送',
        SendViaEmail1: '統一顯示神采問卷的發件郵箱地址:ai@almail.ai-learning.com.cn',
        SendViaEmail2: '每封郵件消耗一條郵件余額,郵件余額需充值購買。',
        MailRemaining: '郵件剩余',
        RechargePurchase: '充值購買',
        SendUsingYourOwnEmail: '使用自有郵箱發送',
        BindingRequired: '需綁定個人郵箱或企業郵箱,顯示您的發件郵箱地址,提升品牌形象,不消耗郵件余額,發送成功率更可靠。',
        LimitedToAdvancedVersionUse: '限高級版使用',
        UpgradeNow: '立即升級',
        NotYetOpen: '暫未開放',
        SentMail: '已發送郵件',
        EmailSubject: '郵件主題',
        SendingMethod: '發送方式',
        Undelivered: '未投遞',
        Delivered: '已投遞',
        DeliveryFailed: '投遞失敗',
        BackToTheListOfSentEmails: '返回已發送郵件列表',
        Mailbox: '郵箱',
        None: '暫無',
        SendConfirmation: '發送確認',
        ContentContainsCharacters: '內容包含字符數',
        NumberOfConsumptionItems: '將消費短信余額條數',
        NumberOfContactsToBeSent: '本條短信將發送聯系人數',
        TotalConsumptionSMSBalance: '總共消費短信余額數',
        SMSBalance: '短信余額',
        Strip: '條',
        Recharge: '充值',
        ReturnToModification: '返回修改',
        ModificationPrompt: '修改提示',
        AreYouSureToModifyThisQuestionnaire: '您確認修改此問卷嗎？該問卷所有數據收集將被停止，答卷鏈接暫時關閉！',
        Wildcard: '$[surveylink] 是代表問卷唯一鏈接的通配符，請勿刪除！刪除後收件人將看不見答題地址。點擊確定可重新添加 $[surveylink]',
        QuestionControl: '題目控件',
        MyQuestionBank: '我的題庫',
        ForExample: '如',
        Recipient: '如：東方艾學',
        Investigate: '神采問卷課調查',
        TelephoneSurveys: '電訪',
        Interview: '面訪',
        SetUp: '設置',
        PleaseWaitAMoment: '請稍後',
        InsufficientSMSBalance: '短信余額不足,請及時充值',
        SuccessfullySent: '發送成功',
        NoContactsToSend: '您無可發送的聯系人',
        FillInTheEmailSubject: '請填寫郵件主題！',
        InsufficientEmailBalance: '郵件余額不足，請充值購買！',
        SuccessfullyCopied: '復制成功！',
        AndaPastiInginMenerbitkan: '確定要發表嗎',
        Penerbitan: '正在發布，請稍後',
        BerjayaDiterbitkan: '發布成功！',
        TidakDiterbitkan: '已取消發布',
        SetBerjaya: '設置成功',
        PadamSecaraKekal: '此操作將永久刪除該數據, 是否繼續?'

    },
  };